// extracted by mini-css-extract-plugin
export var addressFields = "_pw-0";
export var animationContainer = "_pw-1";
export var footer = "_pw-2";
export var lineItems = "_pw-3";
export var modalContent = "_pw-4";
export var orderName = "_pw-5";
export var strong = "_pw-6";
export var warning = "_pw-7";